import { U21Chip, U21ChipProps } from 'app/shared/u21-ui/components';
import { RuleIcon } from 'app/modules/detectionModels/components/RuleIcon';
import { RuleStatuses } from 'app/modules/rules/models';
import { getRouteToRule } from 'app/modules/rules/helpers';
import { RuleTooltip } from 'app/modules/detectionModels/components/RuleTooltip';
import { useSelector } from 'react-redux';
import { selectHasReadRulesPermission } from 'app/modules/session/selectors';
import { ShortRuleResponse } from 'app/modules/rules/types';

interface Props extends Omit<Partial<U21ChipProps>, 'children'> {
  rule: Pick<ShortRuleResponse, 'id' | 'status' | 'title'>;
}

export const RuleChip = (props: Props) => {
  const {
    rule: { status, id, title },
    ...rest
  } = props;
  const hasReadRulesPermission = useSelector(selectHasReadRulesPermission);
  const route = getRouteToRule(
    id,
    hasReadRulesPermission,
    status as RuleStatuses,
  );
  return (
    <U21Chip
      icon={<RuleIcon status={status as RuleStatuses} />}
      onClick={route ? (e) => e.stopPropagation() : undefined}
      to={route}
      tooltip={
        <RuleTooltip id={id} title={title} status={status as RuleStatuses} />
      }
      {...rest}
    >
      {title}
    </U21Chip>
  );
};
